/**
 * GameManagementPage.js
 * Main page for managing games - creating, browsing, and joining
 */

import React, { useState, useEffect } from 'react';
import {
    Box,
    Container,
    Tabs,
    Tab,
    Typography,
    Paper
} from '@mui/material';
import GameCreationWizard from '../components/GameManagement/GameCreationWizard';
import GamesList from '../components/GameManagement/GamesList';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`game-tabpanel-${index}`}
            aria-labelledby={`game-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

export default function GameManagementPage() {
    const [tabValue, setTabValue] = useState(0);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleGameCreated = (game) => {
        console.log('Game created:', game);
        // Trigger refresh of games list
        setRefreshTrigger(prev => prev + 1);
        // Switch to "My Games" tab
        setTabValue(1);
    };

    return (
        <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
            <Paper elevation={3}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'primary.main', color: 'white' }}>
                    <Typography variant="h4" sx={{ p: 2, textAlign: 'center' }}>
                        Game Management
                    </Typography>
                </Box>

                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        aria-label="game management tabs"
                        variant="fullWidth"
                    >
                        <Tab label="Create New Game" id="game-tab-0" aria-controls="game-tabpanel-0" />
                        <Tab label="My Games" id="game-tab-1" aria-controls="game-tabpanel-1" />
                        <Tab label="All Games" id="game-tab-2" aria-controls="game-tabpanel-2" />
                    </Tabs>
                </Box>

                <TabPanel value={tabValue} index={0}>
                    <GameCreationWizard onGameCreated={handleGameCreated} />
                </TabPanel>

                <TabPanel value={tabValue} index={1}>
                    <GamesList
                        title="My Games"
                        refreshTrigger={refreshTrigger}
                        showJoinButton={false}
                    />
                </TabPanel>

                <TabPanel value={tabValue} index={2}>
                    <GamesList
                        title="All Games"
                        refreshTrigger={refreshTrigger}
                        showJoinButton={true}
                    />
                </TabPanel>
            </Paper>
        </Container>
    );
}
